<script setup lang="ts">
const userConfigurationStore = useUserConfigurationStore();
const rolemanagerStore = useRoleManagerStore();
const accountSettingsStore = useAccountSettingsStore();
const platformStore = usePlatformStore();
const { t } = useEkI18n();

const showAssignAsTeamLead = computed(() => userConfigurationStore.isTeamLead || userConfigurationStore.isProjectManager || userConfigurationStore.isConstructionManager || userConfigurationStore.isProjectResponsible);
const showAssignAsProjectManager = computed(() => userConfigurationStore.isProjectManager || userConfigurationStore.isConstructionManager || userConfigurationStore.isProjectResponsible);

</script>

<template>
  <IonContent>
    <SettingsSubMenu
      :title="t('titles.general')"
      icon="fa-light fa-fw fa-mobile"
    >
      <SettingsGeneralTheme />
      <SettingsGeneralLanguage />
      <SettingsGeneralMap v-if="(usePlatformStore().isIos)" />
    </SettingsSubMenu>

    <SettingsSubMenu
      v-if="userConfigurationStore.isLightUser === false"
      :title="t('navbar.homepage')"
      icon="fa-light fa-fw fa-home"
    >
      <SettingsHomepageLayout />
    </SettingsSubMenu>

    <SettingsSubMenu
      v-if="userConfigurationStore.canCreateProject"
      :title="t('titles.createProject', 2)"
      icon="fa-light fa-fw fa-file"
    >
      <SettingsProjectsAssignTeamLead v-if="showAssignAsTeamLead" />
      <SettingsProjectsAssignProjectManager v-if="showAssignAsProjectManager" />
      <SettingsProjectsOpenOnCreation />
    </SettingsSubMenu>

    <SettingsSubMenu
      :title="t('ekomplet.hourRegistration')"
      icon="fa-light fa-fw fa-clock"
    >
      <SettingsHourRegistrationStandardFitterCategory />
      <SettingsHourRegistrationHideEmptyWeekendsInOverview />
      <SettingsHourRegistrationShowNonStandardUnitHourRegistrations />
      <SettingsHourRegistrationShowNonStandardUnitHourRegistrationsDashboard />
    </SettingsSubMenu>

    <SettingsSubMenu
      v-if="userConfigurationStore.isLightUser === false"
      :title="t('ekomplet.worksheet', 2)"
      icon="fa-light fa-fw fa-clipboard"
    >
      <SettingsWorksheetsShowDescription />
      <SettingsWorksheetsShowAllTab v-if="rolemanagerStore.hasShowAllTab" />
      <SettingsWorksheetsShowResponsibleTab v-if="rolemanagerStore.hasShowResponsibleTab" />
      <SettingsWorksheetsStandardTab />
      <SettingsWorksheetsStartToday />
    </SettingsSubMenu>

    <SettingsSubMenu
      v-if="userConfigurationStore.isLightUser === false"
      :title="t('titles.calendar')"
      icon="fa-light fa-fw fa-calendar"
    >
      <SettingsCalendarSaveFilter />
    </SettingsSubMenu>

    <SettingsSubMenu
      v-if="userConfigurationStore.isLightUser === false"
      :title="t('titles.materials')"
      icon="fa-light fa-fw fa-pallet-boxes"
    >
      <SettingsMaterialsGroupMaterials />
      <SettingsMaterialsStandardTab />
      <SettingsMaterialsShowOwnItemImages />
      <SettingsMaterialsShowWholesalerImages />
      <SettingsMaterialsScannerButton />
    </SettingsSubMenu>

    <SettingsSubMenu
      v-if="userConfigurationStore.isLightUser === false"
      :title="t('ekomplet.document', 2)"
      icon="fa-light fa-fw fa-folder"
    >
      <SettingsDocumentsUploadOnCellular />
      <SettingsDocumentsSaveImageToDevice />
      <SettingsDocumentsConvertHeic />
    </SettingsSubMenu>
    <SettingsSubMenu
      v-if="userConfigurationStore.isLightUser === false && platformStore.isMobile"
      :title="t('sidemenu.notification', 2)"
      icon="fa-light fa-fw fa-bell"
    >
      <SettingsNotification v-if="accountSettingsStore._accountSettings?.UsePush === true" />
    </SettingsSubMenu>

    <SettingsReset />
  </IonContent>
</template>

<style scoped>

</style>
